import config from 'js/app/config';

import type { EntWebsiteDomain } from 'bundles/ent-website/components/EntWebsiteDomainContext';
import { DOMAIN_NAME_MAPPINGS, DOMAIN_URL_MAPPINGS } from 'bundles/ent-website/constants/navigation';
import type { BreadcrumbLink } from 'bundles/shared-articles/components/ArticleBreadcrumbs';

import _t from 'i18n!nls/ent-website';

export const genBreadcrumbsForDomain = (domain: EntWebsiteDomain): BreadcrumbLink[] => {
  return [
    { label: DOMAIN_NAME_MAPPINGS[domain], href: `${config.url.base}${DOMAIN_URL_MAPPINGS[domain]}` },
    { label: _t('Articles'), href: `${config.url.base}${DOMAIN_URL_MAPPINGS[domain]}` },
  ];
};
